module.exports = """
  fragment followed_artist_context on HomePageFollowedArtistArtworkModule {
    artist {
      href
      id: slug
    }
  }
"""
